import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${props => props.$bgColor};
  padding: ${props => props.$padding};

  & > * {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 10px;

    @media (min-width: 1200px) {
      padding: 0;
    }
  }
`;
